import React from 'react';
import PragroupLegal from './PragroupLegal';

const UPDATED = 'Last updated: February 17, 2026';

export default function CookiePolicy() {
  return (
    <PragroupLegal badge="Cookies" title="Cookie Policy" updated={UPDATED}>
      <div className="pg-legal-section">
        <h2>1. What Are Cookies?</h2>
        <p>Cookies are small text files stored on your device when you visit a website. They help us recognize your device, remember preferences, and improve your experience. Similar technologies include local storage, session storage, and tracking pixels.</p>
      </div>
      <div className="pg-legal-section">
        <h2>2. Cookies We Use</h2>
        <p><strong>Essential Cookies:</strong> Required for the platform to function. They enable core features like authentication, session management, and security protections. These cannot be disabled.</p>
        <p><strong>Functional Cookies:</strong> Remember your preferences such as language, display settings, and recently viewed assets. They enhance your experience but are not strictly necessary.</p>
        <p><strong>Analytics Cookies:</strong> Help us understand how users interact with our platform — including page views, session duration, and navigation patterns. We use this data to improve performance and usability.</p>
        <p><strong>Marketing Cookies:</strong> Used to deliver relevant advertisements and measure campaign effectiveness. These may be set by third-party partners and track activity across websites.</p>
      </div>
      <div className="pg-legal-section">
        <h2>3. Third-Party Cookies</h2>
        <p>Some cookies are placed by third-party services integrated into our platform, including analytics providers (e.g., Google Analytics), security and fraud prevention services, and advertising networks.</p>
        <p>These third parties have their own privacy policies governing the use of cookies they set.</p>
      </div>
      <div className="pg-legal-section">
        <h2>4. Managing Cookies</h2>
        <p>You can manage cookie preferences through our cookie consent banner displayed on your first visit. You can also adjust settings at any time via the &quot;Cookie Settings&quot; link in the footer.</p>
        <p>Most browsers allow you to block or delete cookies through their settings. Please note that disabling essential cookies may prevent core features from functioning properly.</p>
      </div>
      <div className="pg-legal-section">
        <h2>5. Cookie Retention</h2>
        <p>Session cookies are deleted when you close your browser. Persistent cookies remain on your device for a set period (typically 30 days to 2 years) or until you delete them manually.</p>
        <p>Analytics and marketing cookies typically expire after 12 months.</p>
      </div>
      <div className="pg-legal-section">
        <h2>6. Updates to This Policy</h2>
        <p>We may update this Cookie Policy to reflect changes in technology, regulation, or our practices. The &quot;Last updated&quot; date at the top indicates the most recent revision.</p>
      </div>
      <div className="pg-legal-section">
        <h2>7. Contact</h2>
        <p>If you have questions about our use of cookies, contact us at <strong>privacy@cryptovault.exchange</strong>.</p>
      </div>
    </PragroupLegal>
  );
}
